import {Injectable} from '@angular/core';
import {AdminService} from '../../../../services/admin.service';
import {StepsControllerService} from '../../../../services/steps-controller.service';

@Injectable()
export class AddStepUserService {
  selectedUser;
  lastAddedUser: any;
  successInfo = false;
  errorInfo = false;
  allUsers: any[] = [];
  addedUsers: any[] = [];

  constructor(private adminService: AdminService,
              public stepsControllerService: StepsControllerService) {
  }

  getUsers() {
    return this.allUsers;
  }

  updateAddingUsers() {
    this.allUsers = this.getUsersForAdding();
  }

  getUsersForAdding() {
    this.adminService.getUsersOusideStandard(this.stepsControllerService.getCurrentStandard().id).subscribe(
      (response: any) => {
        if (response.status === 200) {
          this.allUsers = response.body;
        }
      },
      () => {
        this.allUsers = [];
      }
    );
    return this.allUsers;
  }


}



// WEBPACK FOOTER //
// C:/work/internal-frontend/src/app/content-page/admin/create-operating-standard/add-user-steps/add-step-user.service.ts